import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import { BlockDuoMediaDeprecated } from "@hermes/api-model-editorial";

import { SHOULD_PRELOAD_MEDIA, CHAPTERS_PARAGRAPH } from "../../core";

@Component({
    selector: "h-block-duo-media",
    templateUrl: "./block-duo-media.component.html",
    styleUrls: ["./block-duo-media.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BlockDuoMediaComponent {
    blockDuoMedia = inject<BlockDuoMediaDeprecated>(CHAPTERS_PARAGRAPH);
    public shouldPreloadMedia = inject(SHOULD_PRELOAD_MEDIA);
}
